module.exports = __webpack_public_path__ + "media/icons/xlsx-8a73d3c2.svg";